import { injectGlobal } from "styled-components";

import * as colors from '../utils/colors';

import penaltyIcon from '../images/penalty@2x.png';
import penaltyendIcon from '../images/penaltyend@2x.png';

import KlavikaMedium from '../fonts/KlavikaBasic-Medium.ttf';
import KlavikaLight from '../fonts/KlavikaBasic-Light.ttf';
import Colossalis from '../fonts/Colossalis.ttf';

export default injectGlobal`
@font-face {
  font-family: "KlavikaMedium";
  font-style: normal;
  font-weight: normal;
  src: local("KlavikaMedium"), url(${KlavikaMedium}) format('truetype');
}
@font-face {
  font-family: "KlavikaLight";
  font-style: normal;
  font-weight: normal;
  src: local("KlavikaLight"), url(${KlavikaLight}) format('truetype');
}
@font-face {
  font-family: "Colossalis";
  font-style: normal;
  font-weight: normal;
  src: local("Colossalis"), url(${Colossalis}) format('truetype');
}

body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: ${colors.white};
  font-family: KlavikaLight;
}

#___gatsby {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

h1,
h2,
h3,
.colossalis {
  font-family: Colossalis, Arial, sans-serif;
  font-weight: 900;
  margin: 0;
}

.liveticker-event {
  margin-bottom: 20px;

  h1 {
    text-align: center;
  }

  .headline,
  .subheadline {
    font-family: KlavikaMedium;
    margin-bottom: 5px;
  }

  .headline {
    font-size: 1.2em;
  }
}

.gametime {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: KlavikaMedium;
  margin-bottom: 10px;

  &::after {
    border-bottom: 1px solid ${colors.ebbRed};
    position: absolute;
    z-index: 4;
    width: 100%;
    left: 0;
    right: 0;
    height: 1px;
    top: 50%;
    content: '';
    display: block;
  }

  > div {
    position: relative;
    z-index: 5;
    padding: 0;

    > span {
      display: inline-block;
      padding: 3px 5px;
      background-color: ${colors.ebbRed};
    }
  }
}

.penalty,
.penaltyend {
  > .meta {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 10px;

    > .texts {
      flex-grow: 1;
    }

    > .logo,
    > .icon {
      display: block;
      min-width: 60px;
      min-height: 60px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    > .logo {
      margin-right: 10px;
    }

    > .icon {
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
      background-image: url(${penaltyIcon});
    }
  }

  .penaltyend > .icon {
    background-image: url(${penaltyendIcon});
  }
}

.period-label {
  font-size: 20px;
  text-align: center;
  margin-bottom: 5px;
}

.periodstart,
.periodend {
  h1 {
    margin-bottom: 5px;
  }
}

.goal {
  flex-grow: 1;

  .meta {
    display: flex;
    flex-grow: 1;
    margin-bottom: 20px;
  }

  .display {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .team {
    flex-shrink: 1;

    > * {
      visibility: hidden;
    }

    &.scorer {
      > * {
        visibility: visible;
      }
    }

    &.home {
      margin-right: 10px;
    }

    &.visitor {
      margin-left: 10px;
    }
  }

  .logo {
    min-width: 60px;
    min-height: 60px;

    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .score {
    text-align: center;
    font-size: 3rem;

    &.scorer {
      color: ${colors.ebbRed};
    }
  }

  .headline {
    text-align: center;
  }

  .splitter {
    margin-left: 5px;
    margin-right: 5px;
  }

  .player {
    margin-top: 9px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 9px;
    border-top: 1px solid ${colors.white};
    border-bottom: 1px solid ${colors.white};
    display: flex;

    .name {
      font-size: 1.2rem;
      font-family: KlavikaMedium;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-grow: 1;
    }

    .portrait {
      border: 1px solid ${colors.white};
      border-radius: 45px;
      width: 60px;
      height: 60px;
      margin-right: 15px;

      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .number {
      font-family: Colossalis, Arial, sans-serif;
      font-weight: 900;
    }

    &.opponent {
      .number {
        font-size: 2rem;
        transform: translateY(2px);
      }
    }

    &.berlin {
      .number {
        font-size: 3rem;
        transform: translateY(5px);
      }
    }
  }
}

.image {
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
`;



// WEBPACK FOOTER //
// ./src/layouts/global-styles.js